import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Axios from 'axios';

import Filters from './components/Filters';
import Map from './components/Map';
import Sidebar from './components/Sidebar';

import { breakpoints } from '../../../helpers/constants';

const InteractiveMap = ({ title, endpoint, mapId, apiKey }) => {
  const [isDesktop, setIsDesktop] = useState(false);
  const [defaultLocation, setDefaultLocation] = useState(null);
  const [hasAccordion, setHasAccordion] = useState(false);
  const [filters, setFilters] = useState(null);
  const [pins, setPins] = useState(null);
  const [selectedPin, setSelectedPin] = useState(null);

  useEffect(() => {
    const fetchFeed = async () => {
      try {
        const {
          data: { defaultLocation, hasAccordion, filters, pins }
        } = await Axios({
          method: 'GET',
          url: endpoint,
          params: {
            mapId
          }
        });

        setDefaultLocation(defaultLocation);
        setHasAccordion(hasAccordion);
        setFilters(filters.map(filter => ({ ...filter, selected: true })));
        setPins(
          pins.map(pin => {
            const filter = filters.find(
              filter => filter.filterId === pin.filterId
            );
            return {
              ...pin,
              icon: filter.flagImage.icon
            };
          })
        );
      } catch (e) {
        console.log('Error fetching map data.');
      }
    };

    fetchFeed();
  }, [endpoint, mapId]);

  useEffect(() => {
    setSelectedPin(null);
  }, [filters]);

  useEffect(() => {
    const breakpoint = window.matchMedia(
      `(min-width: ${breakpoints.laptop}px)`
    );
    const handleResize = () => {
      setIsDesktop(breakpoint.matches);
    };

    breakpoint.addListener(handleResize);
    handleResize();

    return () => breakpoint.removeListener(handleResize);
  }, []);

  const handleToggleFilter = filterId => {
    const filtersClone = filters.map(filter =>
      filterId === filter.filterId
        ? { ...filter, selected: !filter.selected }
        : filter
    );
    setFilters(filtersClone);
  };

  const handleToggleAllFilters = selectAll => {
    const filtersClone = filters.map(filter => ({
      ...filter,
      selected: selectAll
    }));
    setFilters(filtersClone);
  };

  return defaultLocation ? (
    <>
      {!!title && <h2 className="interactive-map-module__title">{title}</h2>}

      {!!filters && isDesktop && (
        <Filters
          data={filters}
          toggleFilter={handleToggleFilter}
          toggleAllFilters={handleToggleAllFilters}
        />
      )}
      <div className="interactive-map-module__map-container">
        {!!filters && !!pins && (hasAccordion || !isDesktop) && (
          <Sidebar
            filters={filters}
            pins={pins}
            onPinSelect={setSelectedPin}
            isDesktop={isDesktop}
          />
        )}
        {isDesktop && (
          <Map
            apiKey={apiKey}
            mapId={mapId}
            defaultLocation={defaultLocation}
            filters={filters}
            pins={pins}
            selectedPin={selectedPin}
            onPinSelect={setSelectedPin}
          />
        )}
      </div>
    </>
  ) : null;
};

InteractiveMap.propTypes = {
  title: PropTypes.string,
  endpoint: PropTypes.string.isRequired,
  mapId: PropTypes.string.isRequired,
  apiKey: PropTypes.string.isRequired
};

export default InteractiveMap;
